import { createContext } from 'react'

import { IMaterial } from '../constants/types/webinar.types'
import { IEventCard } from '../constants/types/card.types'

interface InitData {
  recommendations: {
    cards: IMaterial[] | IEventCard[]
    isLoaded: boolean
  }
  setRecommend: (key: any) => void
  materialType: string
}

const RecommendationContext = createContext({} as InitData)

export default RecommendationContext
